import { matchPath } from 'react-router';

export function getJobCreatePath(): string {
  return '/job/create';
}

export function useGetJobCreatePath(): string {
  return getJobCreatePath();
}

export function getJobDraftPath(draftId: string): string {
  return `/job/draft/${draftId}`;
}

export function useGetJobDraftPath(draftId: string): string {
  return getJobDraftPath(draftId);
}

export function getJobEditPath(jobId: string): string {
  return `/job/edit/${jobId}`;
}

export function useGetJobEditPath(jobId: string): string {
  return getJobEditPath(jobId);
}

export function getJobCopyPath(jobId: string): string {
  return `/job/copy/${jobId}`;
}

export function useGetJobCopyPath(jobId: string): string {
  return getJobCopyPath(jobId);
}

export function getJobEnhancePath(jobId: string): string {
  return `/job/enhance/${jobId}`;
}

export function useGetJobEnhancePath(jobId: string): string {
  return getJobEnhancePath(jobId);
}

/** Landing / marketing links that open the post-job flow (includes signup query). */
export function getLandingPostJobHref(): string {
  return `${getJobCreatePath()}?signupIfUnauth=true`;
}

/** Prefixes for pathname.startsWith — hide "Post a job" CTA on job posting flows */
export function getJobPostingAreaPathPrefixes(): readonly string[] {
  return ['/job/draft', '/job/create', '/job/copy'];
}

export function useGetJobPostingAreaPathPrefixes(): readonly string[] {
  return getJobPostingAreaPathPrefixes();
}

export function isJobDraftPostingPath(pathname: string): boolean {
  return Boolean(matchPath(pathname, { path: '/job/draft/:id' }));
}

export function isJobCreatePostingPath(pathname: string): boolean {
  return Boolean(matchPath(pathname, { path: '/job/create', exact: true }));
}

export function isJobEnhancePath(pathname: string): boolean {
  return Boolean(
    matchPath(pathname, { path: '/job/enhance/:jobId', exact: true })
  );
}

export function isJobCopyPath(pathname: string): boolean {
  return Boolean(
    matchPath(pathname, { path: '/job/copy/:jobId', exact: true })
  );
}

export function isJobEditPath(pathname: string): boolean {
  return Boolean(
    matchPath(pathname, { path: '/job/edit/:jobId', exact: true })
  );
}
